import { setSelectionRange } from '@testing-library/user-event/dist/utils'
import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>CocktailDB was founded in 2021.The demand for more refined, natural (frequently exotic and tropical) fruit-based beverages. Since its early days Mixer has always been an innovative producer of concentrated fruit purees bottled in “Speed Bottle” containers to facilitate the work of the bartender and later used also to market our line of coffee and Mixology syrups launched in 2022.</p>
    </section>
  )
}

export default About
